import React from 'react';
import { Sparkles, CalendarRange, BarChart3, Gamepad2, Share2 } from 'lucide-react';

const WelcomeOnboarding = ({ isOpen, darkMode, theme, onClose, onExplorePlans, onCreatePlan }) => {
  if (!isOpen) return null;

  const containerStyles = darkMode
    ? 'bg-slate-900 text-white border border-slate-700'
    : 'bg-white text-slate-900 border border-slate-200';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/70 backdrop-blur-sm px-4 py-6" onClick={onClose}>
      <div
        className={`relative w-full max-w-3xl rounded-[32px] p-6 md:p-8 shadow-2xl ${containerStyles}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center gap-3 mb-6">
          <div className={`w-12 h-12 rounded-2xl flex items-center justify-center text-2xl ${theme?.primary || 'bg-emerald-600'} text-white`}>
            <Sparkles className="w-6 h-6" />
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-bold">Welcome to Scurry 🐿️</h2>
            <p className="text-sm opacity-70">The easy way to track your runs, with a dash of squirrel!</p>
          </div>
        </div>

        <div className={darkMode ? 'bg-slate-800 rounded-3xl p-5 border border-slate-700 mb-6' : 'bg-slate-50 rounded-3xl p-5 border border-slate-200 mb-6'}>
          <div className="space-y-4">
            <div className="flex items-start gap-3">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${theme?.light || 'bg-emerald-100'} ${theme?.lightText || 'text-emerald-900'}`}>
                <CalendarRange className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold mb-1">1. Build Your Perfect Plan</p>
                <p className={darkMode ? 'text-xs text-slate-300' : 'text-xs text-slate-600'}>Start with a template or create your own.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${theme?.light || 'bg-emerald-100'} ${theme?.lightText || 'text-emerald-900'}`}>
                <BarChart3 className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold mb-1">2. Store Your Nuts (Data)</p>
                <p className={darkMode ? 'text-xs text-slate-300' : 'text-xs text-slate-600'}>Log runs with a single tap, reorder days, and easily duplicate weeks.</p>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${theme?.light || 'bg-emerald-100'} ${theme?.lightText || 'text-emerald-900'}`}>
                <Gamepad2 className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold mb-1">3. Grow the Forest</p>
                <p className={darkMode ? 'text-xs text-slate-300' : 'text-xs text-slate-600'}>Earn and grow mystery seeds with every mile and collect 40+ kinds of trees.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-3">
          <button
            className={`flex-1 rounded-2xl py-3 text-white font-semibold ${theme?.primary || 'bg-emerald-600'} ${theme?.hover || ''}`}
            onClick={onExplorePlans}
          >
            Browse training plans
          </button>
          <button
            className={`flex-1 rounded-2xl py-3 font-semibold border-2 ${darkMode ? 'border-slate-600 text-white hover:bg-slate-800' : 'border-slate-300 text-slate-900 hover:bg-slate-50'}`}
            onClick={onCreatePlan}
          >
            Start from scratch
          </button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeOnboarding;
